import { isNative, isIos, isAndroid } from '@/lib/platform'

/**
 * App-version tag for the `X-App-Version` request header (see api.ts), stamped
 * onto analyses.app_version server-side so we can tie a user report to the exact
 * build. Resolved ONCE — async on native (Capacitor getInfo) — and then read
 * synchronously by apiFetch. Self-describing so a single column tells you
 * platform + version at a glance:
 *   native → "ios 1.0.4 (52)" / "android 1.0.4 (52)"
 *   web    → "web 1.0.0-<gitHash>-<ts>"
 */
let cached: string | null = null

export async function initAppVersion(): Promise<void> {
  if (cached) return
  try {
    if (isNative()) {
      const { App } = await import('@capacitor/app')
      const info = await App.getInfo()
      const platform = isIos() ? 'ios' : isAndroid() ? 'android' : 'native'
      cached = `${platform} ${info.version} (${info.build})`
    } else {
      // process.env form, not import.meta.env: this module is reachable from the
      // server tsconfig (via api.ts) which has no vite/client types. Vite defines
      // both tokens to the same value — see vite.config.mts.
      cached = `web ${process.env.VITE_BUILD_ID || 'dev'}`
    }
  } catch {
    // Best-effort: on any failure the header is simply omitted (column stays null).
  }
}

export function appVersionTag(): string | null {
  return cached
}
